import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon, SmartphoneIcon } from 'lucide-react';
import { business, navLinks, socials } from '../data/site';
const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${business.address.street}, ${business.address.city}, ${business.address.state} ${business.address.zip}`)}`;
export function SiteFooter() {
  return <footer id="contact" className="w-full bg-ink text-white" data-id="element-194" data-mp="3dh4kqqe1z1fl">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-8 lg:py-20" data-id="element-195" data-mp="38hrnrctgwdza">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,520px)] lg:gap-16" data-id="element-196" data-mp="38gglxijl1gat">
          <div data-id="element-197" data-mp="33j6vbzkgiyle">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="h-14 w-auto" data-id="element-198" data-mp="33krj96c9njaa" />
            <p className="mt-6 max-w-[420px] text-[16px] leading-relaxed text-chalk/70" data-id="element-199" data-mp="11rk0to1cwlk6">
              Specializing in professional results. Give us a call today to
              learn more about the East End Automotive Way!
            </p>

            <a href={business.phoneHref} className="mt-7 inline-flex items-center gap-3 whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-200" data-mp="15sy94f00pwyp">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-201" data-mp="10sag5ns8b61u" />
              Call {business.phone}
            </a>

            <dl className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-202" data-mp="1ojpfr8smf99e">
              <div data-id="element-203" data-mp="1tfwm32oximrv">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-204" data-mp="1tiis2xw68u7z">
                  <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-205" data-mp="1jqms1haiyu14" />
                  Address
                </dt>
                <dd className="mt-2 text-[15px] leading-relaxed text-chalk/85" data-id="element-206" data-mp="27fpa2q92mow5">
                  <a href={mapsHref} target="_blank" rel="noreferrer" className="hover:text-brand-light" data-id="element-207" data-mp="2c6xjvnebcc9u">
                    {business.address.street}
                    <br data-id="element-208" data-mp="2m1mjfwshvwjn" />
                    {business.address.city}, {business.address.state}{' '}
                    {business.address.zip}
                  </a>
                </dd>
              </div>
              <div data-id="element-209" data-mp="2d0ohdk1m9z3p">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-210" data-mp="2d4ca4gz8mhhd">
                  <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="2341yv1wrjk4u" />
                  Hours
                </dt>
                <dd className="mt-2 space-y-1 text-[15px] text-chalk/85" data-id="element-212" data-mp="1yctkrskhnalc">
                  {business.hours.map(h => <p key={h.days} data-id="element-213" data-mp="1tfa5qqfyutsc">
                      <span className="text-chalk/55" data-id="element-214" data-mp="1tc5u58068vrn">{h.days}:</span> {h.time}
                    </p>)}
                </dd>
              </div>
              <div data-id="element-215" data-mp="1kc92qymedisw">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-216" data-mp="1kcsl2gfym97g">
                  <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="1fgtsegnlm518" />
                  Mobile
                </dt>
                <dd className="mt-2 text-[15px] text-chalk/85" data-id="element-218" data-mp="3w0npkbc7vncc">
                  <a href={business.mobileHref} className="hover:text-brand-light" data-id="element-219" data-mp="3w30h9g7s1c2l">
                    {business.mobile}
                  </a>
                </dd>
              </div>
              <div data-id="element-220" data-mp="8vodcii9b3s5">
                <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-chalk/45" data-id="element-221" data-mp="8u3pfbqg6j39">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="3da6bncw1mwb1" />
                  Email
                </dt>
                <dd className="mt-2 break-all text-[15px] text-chalk/85" data-id="element-223" data-mp="3hbhqqohajz4z">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-224" data-mp="3m2q1bnucxqjq">
                    {business.email}
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div data-id="element-225" data-mp="2tkcdmh2qjkyd">
            <a href={mapsHref} target="_blank" rel="noreferrer" className="group block overflow-hidden rounded-xl border border-white/10 bg-charcoal" data-id="element-226" data-mp="2ahtq4pb0ocyb">
              <div className="flex aspect-[16/10] w-full items-center justify-center bg-steel/40" data-id="element-227" data-mp="2k857bdjpoin5">
                <div className="text-center" data-id="element-228" data-mp="2fgdesxgzw2ud">
                  <MapPinIcon className="mx-auto h-8 w-8 text-brand-light" aria-hidden="true" data-id="element-229" data-mp="2fflsyed79jha" />
                  <p className="mt-3 font-display text-lg font-bold tracking-tight" data-id="element-230" data-mp="2o9qfillaw8r0">
                    274 Warehouse Rd, Oak Ridge, TN
                  </p>
                  <p className="mt-1 text-[13px] text-chalk/50 transition-colors duration-150 ease-out group-hover:text-chalk/80" data-id="element-231" data-mp="334equgddu1ej">
                    Interactive map placeholder — opens directions
                  </p>
                </div>
              </div>
            </a>

            <nav aria-label="Footer" className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-232" data-mp="13uy74jleqi8j">
              {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/60 transition-colors duration-150 ease-out hover:text-white" data-id="element-233" data-mp="3fj32e4aja7k6">
                  {link.label}
                </a>)}
            </nav>

            <ul className="mt-6 flex flex-wrap gap-2.5" data-id="element-234" data-mp="2wp671wd7rvea">
              {socials.map(s => <li key={s.label} data-id="element-235" data-mp="30s2t5x1yq9mz">
                  <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex rounded-md border border-white/15 px-3.5 py-2 text-[13px] font-semibold text-chalk/75 transition-colors duration-150 ease-out hover:border-brand hover:text-white" data-id="element-236" data-mp="30t5mebmrco62">
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-7 text-[13px] text-chalk/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-237" data-mp="ok73nbf8m0st">
          <p data-id="element-238" data-mp="ek6j5m5mten1">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
          <p data-id="element-239" data-mp="9lv3uvwkibxf">{business.contact} · EEAutomotiveRepair.com</p>
        </div>
      </div>
    </footer>;
}